import { Navigate } from "react-router-dom";

// Subscription/billing now lives inside the consolidated Settings hub — kept as a redirect so
// every existing navigate("/billing") call site across the app keeps working unchanged.
export default function BillingPage() {
  return <Navigate to="/settings?tab=subscription" replace />;
}
